import React, { useState } from 'react';
import { SimpleDialog } from 'components';
import { Button, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import InputV2 from 'components/InputV2';

const FilterRange = ({ onFilterChanged, columnDef, label, ...rest }) => {
  const { register, handleSubmit, control, formState: { errors } } = useForm();
  const [openDialog, setOpenDialog] = useState(false);

  const onSubmit = (data) => {
    setOpenDialog(false);
    onFilterChanged(columnDef.tableData.id, data);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const openDialogRange = () => {
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" color="primary" type="submit">
          اعمال
        </Button>

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  return (
    <>
      <Button onClick={() => openDialogRange()} variant="outlined">
        انتخاب بازه
      </Button>

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        title="انتخاب بازه "
        onClose={handleCloseDialog}
        formSubmit={handleSubmit(onSubmit)}
        actions={<ActionsBtn />}
      >
        <Grid container alignItems="center" justifyContent="center">
          <Grid item xs={6}>
            <InputV2
              fullWidth
              errors={errors}
              label={`از ${label}`}
              name="from"
              control={control}
              register={register}
              dir="ltr"
              currency
              rules={['required']}
            />
          </Grid>
          <Grid item xs={6}>
            <InputV2
              fullWidth
              errors={errors}
              label={`تا ${label}`}
              name="to"
              control={control}
              register={register}
              dir="ltr"
              currency
              rules={['required']}
            />
          </Grid>
        </Grid>
      </SimpleDialog>
    </>
  );
};

export default FilterRange;
